// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2UD-J","info":"Note_info__17cHE","note":"Note_note__1n5-y","actions":"Note_actions__2UFsX"};